import React from "react";

const STATUS_CONFIG = {
  active: {
    label: "Active",
    className:
      "bg-emerald-50 text-emerald-700 border-emerald-200",
  },

  inactive: {
    label: "Inactive",
    className:
      "bg-slate-100 text-slate-600 border-slate-200",
  },

  pending: {
    label: "Pending",
    className:
      "bg-amber-50 text-amber-700 border-amber-200",
  },

  draft: {
    label: "Draft",
    className:
      "bg-slate-100 text-slate-600 border-slate-200",
  },

  expired: {
    label: "Expired",
    className:
      "bg-orange-50 text-orange-700 border-orange-200",
  },

  terminated: {
    label: "Terminated",
    className:
      "bg-red-50 text-red-700 border-red-200",
  },

  suspended: {
    label: "Suspended",
    className:
      "bg-red-50 text-red-700 border-red-200",
  },
};

const StatusBadge = ({
  status,
  label,
}) => {
  const normalizedStatus = String(
    status || ""
  ).toLowerCase();

  const config =
    STATUS_CONFIG[normalizedStatus] || {
      label: label || status || "Unknown",
      className:
        "bg-slate-100 text-slate-600 border-slate-200",
    };

  return (
    <span
      className={`
        inline-flex
        items-center
        rounded-full
        border
        px-2.5
        py-1
        text-xs
        font-medium
        ${config.className}
      `}
    >
      <span
        className={`
          mr-1.5
          h-1.5
          w-1.5
          rounded-full
          ${
            normalizedStatus === "active"
              ? "bg-emerald-500"
              : normalizedStatus === "pending"
                ? "bg-amber-500"
                : normalizedStatus === "terminated" ||
                    normalizedStatus === "suspended"
                  ? "bg-red-500"
                  : "bg-slate-400"
          }
        `}
      />

      {label || config.label}
    </span>
  );
};

export default StatusBadge;